// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
    demo: {
        title: `English`,
        introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`
    },
    docs: {
        hi: `Hi`,
        description: `Need help? \n Please check our docs.`,
        documentation: `documentation`
    },
    app: `app`,
    list: `list`,
    edit: `edit`,
    shop: `shop`,
    blog: `blog`,
    post: `post`,
    cards: `cards`,
    posts: `posts`,
    create: `create`,
    general: `general`,
    banking: `banking`,
    booking: `booking`,
    profile: `profile`,
    product: `product`,
    invoice: `invoice`,
    details: `details`,
    checkout: `checkout`,
    calendar: `calendar`,
    analytics: `analytics`,
    management: `management`,
    menu_level_1: `menu level 1`,
    menu_level_2: `menu level 2`,
    menu_level_3: `menu level 3`,
    item_disabled: `item disabled`,
    item_label: `item label`,
    item_caption: `item caption`,
    description: `description`,
    other_cases: `other cases`,
    // ----------------------------------------------------------------------
    option_default: `All`,
    // Shipment Status
    option_purchased: `Purchased`,
    option_refunded: `Refund`,
    option_refund_pending: `Refund Pending`,
    option_refund_rejected: `Refund Rejected`,
    // Settings Transaction Type
    option_reward: `Reward`,
    option_payment: `Payment`,
    option_rollback: `Rollback`,
    option_carrier_adjustment: `Carrier Adjustment`,
    option_shipment_adjustment: `Shipment Adjustment`,
    option_promo_credit: `Promo Credit`,
    option_recharge: `Recharge`,
    option_refund: `Refund`,
    option_credit: `Credit`,
    option_subscription: `Subscription`,
    option_bank_account: `Recharge`,
    option_credit_card: `Recharge`,
    option_offline: `Offline Recharge`,
    option_alipay: `Alipay`,
    option_wechatpay: `Recharge`,
    option_purchase: `Purchase`,
    option_void: `Void`,
    option_adjustment: `Carrier Adjustment`,
    option_pickup: `Pickup`,
    // option_zelle_status
    option_pending: `Pending`,
    option_declined: `Declined`,
    // option_credit_card: `Credit Card`,
    option_cancel: `Void`,
    // Settings Payment Type
    option_card: `Credit Card`,
    option_bank: `Bank Account`,
    option_balance: `Account Balance`,
    // Shipment My Shipment Tracking
    option_created: `Label Created`,
    option_in_transit: `In Transit`,
    option_out_for_delivery: `Out for Delivery`,
    option_delivered: `Delivered / Pickup Ready`,
    option_unsuccessful: `Unsuccessful`,
    option_unknown: `Unknown`,
    // Shipment My Pickups Status
    option_confirmed: `Confirmed`,
    option_canceled: `Canceled`,
    // Shipment Pickups Location
    option_front_door: "Front door",
    option_back_door: `Back Door`,
    option_side_door: `Side Door`,
    option_knock_on_door_ring_bell: `Knock on door/Ring Bell`,
    option_mail_room: `Mail room`,
    option_office: `Office`,
    option_reception: `Reception`,
    option_in_at_mail_box: `In/At Mailbox`,
    option_other: `Other (Additional Instructions required)`,
    option_other_s: `Other`,
    // Billing Status
    option_current: `Current`,
    option_expired: `Expired`,
    option_changed: `Changed`,
    option_depleted: `Depleted`,
    // Order Shipping Area
    option_domestic: `Domestic`,
    option_international: `International`,
    // Order Store Status
    option_order_awaiting_payment: `Awaiting Payment`,
    option_order_awaiting: `Awaiting`,
    option_order_shipped: `Shipped`,
    option_order_cancel: `Canceled`,
    option_order_canceled: `Canceled`,
    option_order_cancelled: `Canceled`,
    // ACH Business Type
    option_individual: `Individual`,
    option_company: `Company`,
    // Order Date
    option_all_time: `All Time`,
    option_today: `Today`,
    option_last24h: `Last 24 Hours`,
    option_last7d: `Last 7 days`,
    option_last30d: `Last 30 days`,
    option_last45d: `Last 45 days`,
    option_this1m: `This month`,
    option_last1m: `Last Month`,
    option_custom: `Custom`,
    // Label Size
    option_4x6: `4x6"`,
    option_4x8: `4x8"`,
    option_8_5x11_r: `8.5x11" - Right Side`,
    option_8_5x11_l: `8.5x11" - Left Side`,
    // Residential type
    option_residential: `Residential`,
    option_commercial: `Commercial`,
    // Label Printing Option
    option_ask: `Ask`,
    option_label: `Label`,
    option_qr_code: `QR Code`,
    // Started Shipping
    option_started_shipping_true: `Yes`,
    option_started_shipping_false: `No`,
    // ----------------------------------------------------------------------
    dashboard: `dashboard`,
    orders: `orders`,
    shipments: `shipments`,
    packing: `packing`,
    inventory: `inventory`,
    warehouse: `Warehouse`,
    bins: `Bins`,
    products: `Products`,
    store: `store`,
    stores: `stores`,
    items: `items`,
    wallet: `wallet`,
    payments: `payments`,
    transactions: `transactions`,
    settings: `settings`,
    account: `account`,
    company: `company`,
    printer: `printer`,
    documentation: `documentation`,
    shipping_rule: `shipping rule`,
    address_book: `address book`,
    carrier_accounts: `carrier accounts`,
    user: `user`,
    billing: `billing`,
    reports: `reports`,
    copied: `copied`,
    logout: `logout`,
    // ----------------------------------------------------------------------
    orders_download_succeed: `Succeed`,
    orders_download_failed: `Failed`,
    // ----------------------------------------------------------------------
    response_service_level_desc_GUARANTEE_1: `Service Guarantee`,
    response_service_level_desc_GUARANTEE_2: `.`,
    response_service_level_desc_GUARANTEE_link: `https://www.ups.com/us/en/support/shipping-support/legal-terms-conditions/ups-service-guarantee.page`,
    response_service_level_desc_FIRST_CLASS_MAIL: `Cost-effective way to ship lightweight mails & packages weighing up to 15.99 oz`,
    response_service_level_desc_PRIORITY_MAIL: `Quick and economical way to mail packages under 70 lbs`,
    response_service_level_desc_PRIORITY_MAIL_EXPRESS: `Priority Mail Express® service provides next-day to 2–day delivery service by 6 PM with a `,
    response_service_level_desc_PRIORITY_MAIL_EXPRESS_extra_1: `money–back guarantee`,
    response_service_level_desc_PRIORITY_MAIL_EXPRESS_extra_2: `.`,
    response_service_level_desc_PRIORITY_MAIL_EXPRESS_link: `https://www.usps.com/ship/priority-mail-express.htm#:~:text=Next%2DDay%20to%202%2DDay%20Guarantee1%20%26%20Flat%20Rate%20Pricing&text=Priority%20Mail%20Express%C2%AE%20service,and%20PO%20Boxes%E2%84%A23.`,
    response_service_level_desc_MEDIA_MAIL: `Only for sending books, videotapes, DVDs, CDs, printed music and other sound recordings`,
    response_service_level_desc_LIBRARY_MAIL: `Only for libraries, museums and similar organizations to send items on loan to one another`,
    response_service_level_desc_PARCEL_SELECT_GROUND: `Ground delivery service at very low rates for large or heavy packages`,
    response_service_level_desc_FIRST_CLASS_INTERNATIONAL: `Includes letters, bills, postcards and small packages weighing 4lbs or less`,
    response_service_level_desc_PRIORITY_MAIL_INTERNATIONAL: `Send mail and packages weighing up to 70 lbs`,
    response_service_level_desc_PRIORITY_MAIL_EXPRESS_INTERNATIONAL: `Send international packages up to 70 lbs in 3–5 business days`,
    response_service_level_desc_GROUND: `A cost-effective, reliable ground delivery within 1 - 5 business days.`,
    response_service_level_desc_STANDARD: `Guaranteed economical ground delivery for less-urgent shipments`,
    response_service_level_desc_SAVER: `Guaranteed afternoon delivery times in 1-3 days for international shipments`,
    response_service_level_desc_WORLDWIDE_EXPRESS: `Guaranteed morning delivery times in 1-3 days for international shipments.`,
    response_service_level_desc_WORLDWIDE_EXPRESS_PLUS: `Guaranteed early-morning, day-definite delivery for international shipments`,
    response_service_level_desc_WORLDWIDE_EXPEDITED: `Guaranteed economical delivery for less urgent international shipments`,
    response_service_level_desc_NEXT_DAY_AIR: `Guaranteed next-business-day delivery from and to most addresses in the US50 and Puerto Rico`,
    response_service_level_desc_NEXT_DAY_AIR_SAVER: `Guaranteed next-business-day delivery from and to most addresses in the US48`,
    response_service_level_desc_NEXT_DAY_AIR_EARLY: `Guaranteed early-morning, next-business-day delivery`,
    response_service_level_desc_SECOND_DAY_AIR: `Guaranteed 2nd-business-day delivery from and to most addresses in the US50 and Puerto Rico`,
    response_service_level_desc_SECOND_DAY_AIR_AM: `Guaranteed morning 2nd-business-day delivery from most commercial addresses`,
    response_service_level_desc_THIRD_DAY_SELECT: `Guaranteed 3-working-day delivery`,
    response_service_level_desc_SMART_POST: `A cost-effective solution for shipping packages domestically in the U.S. that weigh under 70 pounds`,
    response_service_level_desc_SUREPOST_LESS_1LB: `An economy service for your non-urgent packages`,
    response_service_level_desc_SUREPOST_1LB_GREATER: `An economy service for your non-urgent packages`,
    response_service_level_desc_DHL_EXPRESS_WORLDWIDE: `Premium worldwide express service by air, only for documents`,
    response_service_level_desc_DHL_EXPRESS_WORLDWIDE_NONDOC: `Premium worldwide express service by air`,
    response_service_level_desc_DHL_EXPRESS_1200: `Delivery before 12 noon on the next possible delivery day. Money-back guarantee included.`,
    response_service_level_desc_DHL_EXPRESS_1200_NONDOC: `Delivery before 12 noon on the next possible delivery day. Money-back guarantee included.`,
    response_service_level_desc_DHL_EXPRESS_ENVELOPE: `With DHL Express Envelope, you can ensure documents that are not subject to customs processes.`,
    response_service_level_desc_DHL_MEDICAL_EXPRESS: `The ideal solution for time and temperature sensitive life science & healthcare shipments.`,
    response_service_level_desc_DHL_MEDICAL_EXPRESS_NODOC: `The ideal solution for time and temperature sensitive life science & healthcare shipments.`,
    response_service_level_desc_DHL_PARCEL_EXPEDITED_MAX: ``,
    response_service_level_desc_DHL_PACKET_INTERNATIONAL: `Access to your own pre-negotiated rates.`,
    response_service_level_desc_DHL_PARCEL_INTERNATIONAL_STANDARD: `Access to your own pre-negotiated rates.`,
    response_service_level_desc_DHL_PARCEL_INTERNATIONAL_DIRECT: `Access to your own pre-negotiated rates.`,
    response_service_level_desc_ONTRAC_SUNRISE: `OnTrac offers Sunrise, Sunrise Gold, Ground & Palletized Freight shipping services to meet your custom shipping needs.`,
    response_service_level_desc_ONTRAC_SUNRISE_GOLD: `OnTrac offers Sunrise, Sunrise Gold, Ground & Palletized Freight shipping services to meet your custom shipping needs.`,
    response_service_level_desc_ONTRAC_PALLETIZED_FREIGHT: `OnTrac offers Sunrise, Sunrise Gold, Ground & Palletized Freight shipping services to meet your custom shipping needs.`,
    response_service_level_desc_ONTRAC_GROUND: `OnTrac offers Sunrise, Sunrise Gold, Ground & Palletized Freight shipping services to meet your custom shipping needs.`,
    response_service_level_desc_ONTRAC_SAME_DAY: `OnTrac offers Sunrise, Sunrise Gold, Ground & Palletized Freight shipping services to meet your custom shipping needs.`,
    response_service_level_desc_FEDEX_INTERNATIONAL_CONNECT_PLUS: `Suitable for shipments weighing 70 lbs or less, and do not contain hazardous materials`,
    response_service_level_desc_USPS_GROUND_ADVANTAGE: `An affordable and reliable way to ship packages in 2–5 business days`,
    // ----------------------------------------------------------------------
    payment_payment_methods_verify_first_fail: `2 attempts remaining.`,
    payment_payment_methods_verify_fail_1: `2 attempts remaining. `,
    payment_payment_methods_verify_fail_2: `Please log into your bank account to confirm the last two digits of the transaction amounts.`,
    payment_payment_methods_verify_second_fail_1: `Warning: Only 1 attempt left. `,
    payment_payment_methods_verify_second_fail_2: `Check for your recent transactions marked as 'SHIP SAVING' in your bank account.`,
    payment_payment_methods_verify_fail: `You have used all your attempts. For your account's security, please contact our customer support.`
};

export default en;
